<template>
  <div
    :class="rootClassName"
  >
    <slot v-if="open" />
  </div>
</template>

<script>

export default {
  name: 'Collapse',

  props: {
    open: Boolean
  },
  computed: {
    rootClassName () {
      return [ 'collapse' ]
    }
  }
}

</script>

<style scoped>

</style>
